export const SUJETO_RETENIDO_TYPES = [
    {
      value: "01",
      name: "Persona Natural",
    },
    {
      value: "02",
      name: "Sociedad",
    }
  ]